// below changes are related to Persist Tab Across Page Refresh
import { createContext, useContext, useState, useEffect } from 'react';

const TabContext = createContext();

export function TabProvider({ children }) {
  const [activeTab, setActiveTab] = useState(null); // ⛔️ not 'tab1' by default
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('activeTab');
    setActiveTab(saved || 'tab1');
    setReady(true);
  }, []);

  useEffect(() => {
    if (activeTab) {
      localStorage.setItem('activeTab', activeTab);
    }
  }, [activeTab]);

  return (
    <TabContext.Provider value={{ activeTab, setActiveTab, ready }}>{children}</TabContext.Provider>
  );
}

export function useTabContext() {
  return useContext(TabContext);
}
